import * as actionTypes from '../../actions';
import store from '../../index';
import api from 'api';

export const setViewingUser = async(ignoreIfFound) => {
    return new Promise( async resolve => {


        //see if we know who the user is
        //we include a cookie with there id here to account for cors issues
        const viewing_user = await api.auth.viewing_user()

        if(viewing_user.success) {
            if(ignoreIfFound && viewing_user.data) return resolve({success: true, data: viewing_user.data});

            store.dispatch({ type: actionTypes.SET_VIEWING_USER, payload: { objects: viewing_user.data } });
            resolve({success: true, data: viewing_user.data});

        } else {

            resolve({success: false});

        }

    })

}

export const setViewingUserByValue = async(user) => {
    store.dispatch({ type: actionTypes.SET_VIEWING_USER, payload: { objects: user } });
}
